var map = {
	"./customer10_BR1_1.json": 6101,
	"./customer10_BR3_1.json": 3661,
	"./customer10_BR7_1.json": 1155,
	"./customer1_BR1_1.json": 7377,
	"./customer1_BR3_1.json": 4426,
	"./customer1_BR7_1.json": 6771,
	"./customer2_BR1_1.json": 8739,
	"./customer2_BR3_1.json": 1960,
	"./customer2_BR7_1.json": 2282,
	"./customer5_BR1_1.json": 5404,
	"./customer5_BR2_1.json": 7122,
	"./customer5_BR3_1.json": 1045,
	"./customer5_BR4_1.json": 5456,
	"./customer5_BR5_1.json": 9819,
	"./customer5_BR6_1.json": 264,
	"./customer5_BR7_1.json": 2604
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4338;